import styled from "@emotion/styled";
import { Flex } from "@otrium/core";
import { HyperLink } from "src/atoms/HyperLink";

const ModalWrapper = styled(Flex)`
  position: relative;
  width: 532px;
  max-width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${({ theme }) => theme.space.space16};
  padding: ${({ theme }) =>
    `${theme.space.space48} ${theme.space.space16} ${theme.space.space32}`};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding: ${({ theme }) => theme.space.space32};
  }
  .ProductOrder__order button {
    max-width: 100%;
  }
`;

const SocialButtonsContainer = styled(Flex)`
  width: 100%;
  justify-content: space-between;
`;

const InlineHyperLink = styled(HyperLink)`
  display: inline;
  text-decoration: underline;
  &:hover {
    text-decoration-thickness: unset;
    text-decoration: underline;
    text-underline-position: unset;
  }
`;

export const Divider = styled.div`
  position: relative;
  display: flex;
  place-items: center;
  justify-content: center;

  span {
    padding-inline: ${({ theme }) => theme.space.space8};
    background-color: ${({ theme }) => theme.colors.tone.white};
    z-index: 10;
  }

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.tone.marble};
    z-index: 1;
  }
`;

export { ModalWrapper, SocialButtonsContainer, InlineHyperLink };
